export const ALERT_PER_USER_MAX = 50;
export const MAX_INVALID_CONTEXT_DURATION = 35;
export const ALERT_SHARING_COMMENT_MAX_LENGTH = 140;
//# sourceMappingURL=constants.js.map